import React from "react";
import { object, number } from "prop-types";

import StoryElements from "../story-elements";
import StoryHeader from "../header-block";
import StorySideBar from "../story-sidebar-elements";
import { getSectionName } from "../../../components/utils/utils";

import "./text.m.css";

const TextStoryTemplate = ({ story, index }) => {
  const isPodcast = story["story-template"] === "podcast" || getSectionName(story) === "Podcast";

  return (
    <div styleName="story-wrapper">
      <div>
        <StoryHeader story={story} showHeroImage={!isPodcast} />
        <StoryElements story={story} cards={story.cards} index={index} />
      </div>
      <StorySideBar index={index} story={story} />
    </div>
  );
};

TextStoryTemplate.propTypes = {
  story: object,
  index: number,
};

function TextStory(props) {
  return (
    <div>
      <TextStoryTemplate story={props.story} index={props.index} />
    </div>
  );
}

TextStory.propTypes = {
  story: object,
  index: number,
};

export default TextStory;
